<template>
    <el-dialog @close='closeDialog' title="助力排行" :visible.sync="dialogVisible">
        <div class="help_rank_warp">
            <div class="help_rank_table_box">
                <el-table :data="helpRankTableData" style="width: 100%" max-height="424">
                    <el-table-column property="index" width="100" label="序号" align='center'></el-table-column>
                    <el-table-column label="用户名称">
                        <template slot-scope="scope">
                            <div class="user_box">
                                <!-- <img :src="require('@/common/images/communityPurchases/logo.png')" alt=""> -->
                                <img :src="scope.row.customericonurl" alt="">
                                <span>{{scope.row.customername}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="factasscount" label="助力人数" align='center'></el-table-column>
                </el-table>
            </div>
            <div class="page_box">
                <el-pagination
                    background
                    @current-change="handleSizeChange"
                    :current-page.sync="pageParams.page"
                    :page-size="pageParams.pagesize"
                    :pager-count="11"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {mapActions} from 'vuex' // 引入 vuex 组件
import {getAssEventRankList} from 'api/taskToolsApi'
export default {
    name: 'HelpRankPop',
    data() {
        return {
            dialogVisible: false,
            helpRankTableData: [],
            total: 0,
            pageParams: {
                page: 1,
                pagesize: 5
            },
            eventinnerid: ''
        }
    },
    mounted() {},
    methods: {
        // 打开弹窗
        openDialog(val) {
            this.dialogVisible = true
            this.eventinnerid = val.eventinnerid
            this.handleSizeChange(val)
        },
        // 关闭弹框
        closeDialog() {
            this.dialogVisible = false
            this.helpRankTableData = []
            this.total = 0
            this.pageParams.page = 1
        },
        // 助力排行分页
        handleSizeChange(val) {
            // this.$message.success(`当前页数：${this.pageParams.page}`)
            this.setLoading(true)
            var params = {
                eventinnerid: this.eventinnerid
            }
            getAssEventRankList({
                data: Object.assign({}, params, this.pageParams),
                success: data => {
                    this.setLoading(false)
                    this.helpRankTableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .help_rank_warp {
        color: #303133;
        .help_rank_table_box {
            .el-table {
                height: 424px;
            }
            // .el-table th>.cell {
            //     font-weight: bold!important;
            //     white-space: nowrap;
            //     font-size: 16px;
            // }
            .el-table__empty-block {
                min-height: 300px;
                padding-top: 200px;
                box-sizing: border-box;
            }
            .user_box{
                display: flex;
                align-items: center;
                img{
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    margin-right: 10px;
                }
            }
        }
        .page_box{
            margin-top: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
</style>